import gql from "graphql-tag";

export const ApprovalFragment = gql`
  fragment ApprovalFragment on AdminApproval {
    _id
    tour {
      _id
    }
    rejectReasons
    comments
    status
    createdAt
  }
`;